/* tslint:disable */
/* eslint-disable */
/**
 * Tardek API Endpoints
 * This Is a documentation for T1 Tardek API Endpoints. <br />
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: info@bitweb.ee
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 *
 * @export
 * @interface UpdateDocumentRequestV3
 */
export interface UpdateDocumentRequestV3 {
    /**
     * Document ID
     * @type {number}
     * @memberof UpdateDocumentRequestV3
     */
    'id': number;
    /**
     * Internal type of the document
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'type': UpdateDocumentRequestV3TypeEnum;
    /**
     * Document Reference Number
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'referenceNumber'?: string;
    /**
     * Document Transport Document Reference Number
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'transportDocumentReferenceNumber'?: string;
    /**
     * Document Complement of information
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'complementOfInformation'?: string;
    /**
     * Document line number
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'documentLineItemNumber'?: string;
    /**
     * Document Type
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'documentType': string;
    /**
     * Consignment Item ID
     * @type {number}
     * @memberof UpdateDocumentRequestV3
     */
    'consignmentItemId'?: number | null;
    /**
     * Consignment ID
     * @type {number}
     * @memberof UpdateDocumentRequestV3
     */
    'consignmentId'?: number | null;
    /**
     * House consignment ID
     * @type {number}
     * @memberof UpdateDocumentRequestV3
     */
    'houseConsignmentId'?: number | null;
    /**
     * Transit Operation ID
     * @type {number}
     * @memberof UpdateDocumentRequestV3
     */
    'transitOperationId': number;
    /**
     * Document Sequence Number
     * @type {number}
     * @memberof UpdateDocumentRequestV3
     */
    'sequenceNumber': number;
    /**
     * Document Previous Procedure Type
     * @type {string}
     * @memberof UpdateDocumentRequestV3
     */
    'procedureType'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateDocumentRequestV3TypeEnum {
  PREVIOUS = 'PREVIOUS',
  SUPPORTING = 'SUPPORTING',
  TRANSPORT = 'TRANSPORT',
  NOTE = 'NOTE',
  GLOBAL = 'GLOBAL'
}


